import type { CertificateView } from "~~/model/certificate.model";

export function useCertificateContent(certificate: CertificateView) {
  const locale = computed(
    () => certificate.session.course.languages[0] ?? "fr",
  );

  const issueDate = useI18nDate(certificate.created_at, {
    locale: locale.value,
  });

  const content = computed(() => {
    return {
      title: certificate.session.course.title,
      teachers: certificate.session.course.teacher.full_name,
    };
  });

  return {
    locale,
    issueDate,
    content,
  };
}
